import React from 'react';
import {Container,Row,Col,Table} from 'react-bootstrap';
import './index.scss';
import { Outlet, Link, Navigate } from "react-router-dom";

import Button  from "../../common/Button";


function Headers(props){
    return (
        <>
         <th style={{whiteSpace: "nowrap"}}>{props.name}</th>
        </>
    );
}


function Tdata(props){


    return(
        <td>{props.text}</td>
    );
}

function TRow(props){
    let data = [];
    for (let key in props.id) {
         data.push(props.id[key]); 
    }


    return (
        <>
        <tr className='text-secondary'>

      {data.map((member) => <Tdata key={member} text={member}  />)}
     
      <td className='d-flex flex-row'>

        <span className='button border bg-secondary rounded text-warning mr-1 ml-1 p-1'>
        <Link className='text-warning small' style={{whiteSpace: "nowrap"}} to={props.edit +'?id=' + props.ide}><i className='fa fa-pencil mr-1'></i> Edit</Link>
        </span>

        <span className='button border bg-danger rounded p-1 mr-1 ml-1'>
        <Link className='text-white small  hover' style={{whiteSpace: "nowrap"}} to={props.delete+'?id=' + props.ide}><i className='fa fa-close mr-1'></i>Delete</Link>
        </span>

      </td>
    </tr>
        
        </>
    );
}

export default function TableUser(props){
    return(

<Container fluid className='home-table rounded m-0 bg-white p-2 position-relative right-0'>

<Container fluid className='d-flex table-header-home position-sticky right-0' >
    <div className="m-1 ">
        <h3>{props.name}</h3>
    </div>
    <div className='w-100 position-sticky right-0 export-btns'>
        {props.buttons.map((button) =>  <Button key={button.id} path = {button.path} title={button.title} active="btn-deactive float-right" />)}

    </div>
</Container>
<hr/>

<Table striped bordered hover>
<thead>
<tr>
{props.table_headers.map((name) => <Headers key={name.id} name={name.name}   />)}
</tr>
</thead>
<tbody>

{props.members.map((member) => <TRow key={member.id} edit={props.edit} delete={props.delete} id={member} ide={member.id} />)}
</tbody>
</Table>

</Container>
    );
}